import { useSyncExternalStore } from 'react';
import { useQuery } from '@tanstack/react-query';
import { adsApi } from '../../api/ads';
import { useWebLocale } from '../../contexts/WebLocaleContext';
import { selectCampaigns } from './placement';
const key = 'POSTPOP_WEB_HIDDEN_SPONSORED_CAMPAIGNS_V1';
const read = () => {
  try {
    const value = JSON.parse(localStorage.getItem(key) || '[]');
    return Array.isArray(value) ? value.filter(Number.isSafeInteger).slice(-200) : [];
  } catch {
    return [];
  }
};
let hidden = read();
const listeners = new Set();
const emit = () => listeners.forEach((listener) => listener());
const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
window.addEventListener('storage', (event) => {
  if (event.key === key || event.key === null) {
    hidden = read();
    emit();
  }
});
export function hideCampaign(id) {
  hidden = [...new Set([...hidden, id])].slice(-200);
  try {
    localStorage.setItem(key, JSON.stringify(hidden));
  } catch {
    /* Still hidden this session. */
  }
  emit();
}
export function useSponsoredPlacements(placementKey) {
  const { locale } = useWebLocale();
  const hiddenIds = useSyncExternalStore(subscribe, () => hidden);
  const query = useQuery({
    queryKey: ['web-sponsored-content', locale],
    queryFn: ({ signal }) => adsApi.placements(locale, signal),
    staleTime: 60000,
    retry: 1,
  });
  return selectCampaigns(query.data?.campaigns, placementKey, hiddenIds);
}
